module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/team.json
// module id = 1044
// module chunks = 196979586499782